<template>
    <div>
        <nav-bar />
        <aside-menu :menu="menu" />
        <app-main />
    </div>
</template>

<script>
const AsideMenu = () => import('@/components/AsideMenu');
const NavBar = () => import('@/components/NavBar');
const AppMain = () => import('@/components/AppMain');

export default {
    name: 'layout',
    components: {
        AsideMenu,
        NavBar,
        AppMain,
    },
    computed: {
        menu() {
            return [
                'General',
                [
                    {
                        to: '/admin/dashboard',
                        icon: 'desktop-mac',
                        label: 'Dashboard',
                    },
                ],
                'Declaratia 230',
                [
                    {
                        to: '/admin/formular-230/exporturi',
                        label: 'Exporturi',
                        icon: 'database-export',
                        updateMark: true,
                    },
                    {
                        to: '/admin/formular-230/conturi',
                        label: 'Conturi',
                        icon: 'account-group',
                    },
                    {
                        to: '/admin/formular-230/formulare-manuale/2025',
                        label: 'Formulare hartie 2025',
                        icon: 'format-list-bulleted-square',
                        updateMark: true,
                    },
                    {
                        to: '/admin/formular-230/formulare/2025',
                        label: 'Formulare 2025',
                        icon: 'format-list-bulleted-square',
                        updateMark: true,
                    },
                    {
                        to: '/admin/formular-230/formulare-manuale/2024',
                        label: 'Formulare hartie 2024',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare/2024',
                        label: 'Formulare 2024',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare-manuale/2023',
                        label: 'Formulare hartie 2023',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare/2023',
                        label: 'Formulare 2023',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare-manuale/2022',
                        label: 'Formulare hartie 2022',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare/2022',
                        label: 'Formulare 2022',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare-manuale/2021',
                        label: 'Formulare hartie 2021',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare/2021',
                        label: 'Formulare 2021',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare-manuale/2020',
                        label: 'Formulare hartie 2020',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare/2020',
                        label: 'Formulare 2020',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                    {
                        to: '/admin/formular-230/formulare/2019',
                        label: 'Formulare 2019',
                        icon: 'format-list-bulleted-square',
                        updateMark: false,
                    },
                ],
            ];
        },
    },
    created() {
        document.documentElement.style.backgroundColor = '#f8f8f8';
        document.documentElement.className =
            'has-aside-left has-aside-mobile-transition has-navbar-fixed-top has-aside-expanded';
    },
    beforeDestroy() {
        document.documentElement.className = '';
    },
};
</script>
<style scoped>
::v-deep html {
    background-color: #f8f8f8 !important;
}
</style>
